import React, { useState } from 'react';
import Footer from '../navbar/Footer';
import NavigationBar from '../navbar/NavigationBar';
import {
  Box,
  Typography,
  Container,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  Divider,
  IconButton,
  Tooltip,
  TextField,
  List, 
  ListItem, 
  ListItemIcon,
  ListItemText,
  CssBaseline,
  Drawer,
  InputAdornment,
  Button,
  useTheme,
  ListItemButton,
  Link,
  styled,
  useMediaQuery,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Menu,
  MenuItem,
  Card,
  CardContent,
} from '@mui/material';
import {
  Layers,
  InsertDriveFile,
  Description,
  MoreVert,
  Search,
  FileCopy,
  Download,
  Share,
  Home,
  Nature,
  Menu as MenuIcon,
  School,
  Close,
  FamilyRestroom,
  Man,
  TrendingUp,
  Public,
  ExpandMore,
  Email,
  WhatsApp,
  Groups,
  LocalHospital,
  Person,
  Grass,
  Spa,
  BugReport,
  Hive,
  Water as WaterIcon,
  Groups3,
  Handshake,
  Diversity3,
  House,
  Roofing,
  Map,
  Pets as LivestockIcon,
  EggAlt as PoultryIcon,
  Cottage as EmergencyHomeIcon, 
  AccessibilityNew, 
  ChildCare, 
  Terrain, 
  PictureAsPdf,
  Engineering 
} from '@mui/icons-material';

// Constantes de style
const drawerWidth = 240;
const primaryColor = '#E30613';
const secondaryColor = '#008D36';
const backgroundColor = '#f5f5f5';

// Composants stylisés
const MainContainer = styled('div')({
  display: 'flex',
  backgroundColor: backgroundColor,
  minHeight: '100vh',
  flexDirection: 'column'
});

const MainContentWithDrawer = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  marginTop: '64px',
  overflow: 'hidden',
  [theme.breakpoints.down('sm')]: {
    marginTop: '56px'
  }
}));

const ContentWrapper = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  padding: theme.spacing(2),
  backgroundColor: backgroundColor,
  height: 'calc(100vh - 64px)',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(1),
    height: 'calc(100vh - 56px)'
  }
}));

const DrawerWrapper = styled('div')(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  overflow: 'auto',
  height: 'calc(100vh - 64px)',
  borderRight: '1px solid rgba(0, 0, 0, 0.12)',
  backgroundColor: '#fff',
  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    zIndex: 1300,
    transition: theme.transitions.create('transform', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    '&.drawerOpen': {
      transform: 'translateX(0)',
    },
    '&.drawerClose': {
      transform: 'translateX(-100%)',
    },
  }
}));

const MobileDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}));

const StyledTableHead = styled(TableHead)({
  backgroundColor: primaryColor,
  '& th': {
    color: 'white',
    fontWeight: 'bold'
  }
});

const AgeGroupRow = styled(TableRow)({
  '&:hover': {
    backgroundColor: '#f5f5f5 !important'
  }
});

const menuItems = [
  { text: 'Ménages par type', icon: <FamilyRestroom color="primary" />, to: '/RGPHAEDataPage' },
  { text: 'Population par localisation', icon: <Public color="primary" />, to: '/PopulationDataPage' },
  { text: 'Ménages collectifs', icon: <Groups color="primary" />, to: '/PopulationCollectiveHouseholdsPage' },
  { text: 'Sans-abris', icon: <EmergencyHomeIcon color="primary" />, to: '/HomelessPopulationPage' },
  { text: 'Ménages ordinaires', icon: <Home color="primary" />, to: '/PopulationResidentPage' },
  { text: 'Sexe et masculinité', icon: <Man color="primary" />, to: '/PopulationDataPageM' },
  { text: 'Rapport de masculinité', icon: <TrendingUp color="primary" />, to: '/MasculinityRatioPage' },
  { text: 'Population par âge', icon: <ChildCare color="primary" />, to: '/PopulationDataPageAge' },
  { text: "Grands groupes d'âge", icon: <AccessibilityNew color="primary" />, to: '/PopulationAgeGroupPageGrand' },
  { text: "Groupes d'âge (éducation)", icon: <School color="primary" />, to: '/PopulationByAgeGroupPage' },
  { text: 'Groupes d\'âge (santé)', icon: <LocalHospital color="primary" />, to: '/AgeGroupPopulationPage' },
  { text: 'Adultes (18+)', icon: <Person color="primary" />, to: '/AdultPopulationPage' },
  
  // Agriculture
  { text: 'Ménages agricoles', icon: <Nature color="primary" />, to: '/AgriculturalHouseholdsPage' },
  { text: 'Pratiques agricoles', icon: <Grass color="primary" />, to: '/AgriculturalHouseholdsPages' },
  { text: 'Types de cultures', icon: <Spa color="primary" />, to: '/AgriculturalHouseholdsPage20' },
  
  // Élevage
  { text: 'Élevage par espèces', icon: <LivestockIcon color="primary" />, to: '/FarmingHouseholdsPage' },
  { text: 'Élevage de volailles', icon: <PoultryIcon color="primary" />, to: '/poultryFarmingPage' },
  { text: 'Élevage spécial', icon: <BugReport color="primary" />, to: '/insectFarmingHouseholdsPage' },
  { text: 'Répartition cheptel', icon: <LivestockIcon color="primary" />, to: '/livestockDistributionPage' },
  { text: 'Répartition volailles', icon: <PoultryIcon color="primary" />, to: '/poultryDistributionPage' },
  
  // Matériel agricole
  { text: 'Équipements agricoles', icon: <Engineering color="primary" />, to: '/agriculturalEquipmentPage' },
  { text: 'Apiculture', icon: <Hive color="primary" />, to: '/beekeepingHouseholdsPage' },
  { text: 'Pêche/aquaculture', icon: <WaterIcon color="primary" />, to: '/fishingHouseholdsPage' },
  
  // Associations
  { text: 'Interventions associations', icon: <Groups3 color="primary" />, to: '/associationInterventionPage' },
  { text: 'Interventions coopératives', icon: <Handshake color="primary" />, to: '/cooperativeInterventionPage' },
  { text: 'Interventions ONG', icon: <Diversity3 color="primary" />, to: '/interventionProjectsPage' },
  
  // Habitat
  { text: "Type d'habitat", icon: <House color="primary" />, to: '/housingDistributionPage' },
  { text: 'Matériau toit', icon: <Roofing color="primary" />, to: '/roofMaterialPage' },
  { text: 'Matériau sol', icon: <Layers color="primary" />, to: '/housingMaterialPage' },
  { text: 'Ménages agricoles', icon: <Terrain color="primary" />, to: '/agriculturalHouseholdsPageProvCom' },
  { text: 'Population par âge/résidence', icon: <Map color="primary" />, to: '/populationAgeResidencePage' },
];

// Données de répartition par âge, sexe et milieu de résidence
const populationData = {
  "title": "Répartition de la population des ménages ordinaires par âge selon le sexe et le milieu de résidence",
  "totalPopulation": "12 220 934",
  "ageGroups": [
    {
      "group": "0 - 14 ans",
      "total": "5 505 806",
      "urban": {
        "total": "1 210 028",
        "male": "600 583",
        "female": "609 445"
      },
      "rural": {
        "total": "4 295 778",
        "male": "2 154 339",
        "female": "2 141 439"
      }
    },
    {
      "group": "15 - 59 ans",
      "total": "6 027 615",
      "urban": {
        "total": "1 673 655",
        "male": "828 407",
        "female": "845 248"
      },
      "rural": {
        "total": "4 353 960",
        "male": "1 927 796",
        "female": "2 426 164"
      }
    },
    {
      "group": "60 ans et plus",
      "total": "687 513",
      "urban": {
        "total": "106 783",
        "male": "49 776",
        "female": "57 007"
      },
      "rural": {
        "total": "580 730",
        "male": "262 174",
        "female": "318 556"
      }
    }
  ],
  "detailedAgeGroups": [
    {
      "group": "< 1 ans",
      "total": "445 592",
      "urban": {
        "total": "101 925",
        "male": "51 030",
        "female": "50 895"
      },
      "rural": {
        "total": "343 667",
        "male": "171 338",
        "female": "172 329"
      }
    },
    {
      "group": "1 ans",
      "total": "390 278",
      "urban": {
        "total": "89 845",
        "male": "45 013",
        "female": "44 832"
      },
      "rural": {
        "total": "300 433",
        "male": "150 425",
        "female": "150 008"
      }
    },
    {
      "group": "2 ans",
      "total": "406 820",
      "urban": {
        "total": "91 343",
        "male": "45 701",
        "female": "45 642"
      },
      "rural": {
        "total": "315 477",
        "male": "158 072",
        "female": "157 405"
      }
    },
    {
      "group": "3 ans",
      "total": "404 506",
      "urban": {
        "total": "87 916",
        "male": "44 162",
        "female": "43 754"
      },
      "rural": {
        "total": "316 590",
        "male": "158 893",
        "female": "157 697"
      }
    },
    {
      "group": "4 ans",
      "total": "393 869",
      "urban": {
        "total": "86 653",
        "male": "43 967",
        "female": "42 686"
      },
      "rural": {
        "total": "307 216",
        "male": "154 269",
        "female": "152 947"
      }
    },
    {
      "group": "5 ans",
      "total": "398 863",
      "urban": {
        "total": "84 212",
        "male": "42 380",
        "female": "41 832"
      },
      "rural": {
        "total": "314 651",
        "male": "158 522",
        "female": "156 129"
      }
    },
    {
      "group": "6 ans",
      "total": "365 093",
      "urban": {
        "total": "80 620",
        "male": "40 518",
        "female": "40 102"
      },
      "rural": {
        "total": "284 473",
        "male": "142 812",
        "female": "141 661"
      }
    },
    {
      "group": "7 ans",
      "total": "357 361",
      "urban": {
        "total": "77 686",
        "male": "39 272",
        "female": "38 414"
      },
      "rural": {
        "total": "279 675",
        "male": "140 555",
        "female": "139 120"
      }
    },
    {
      "group": "8 ans",
      "total": "357 284",
      "urban": {
        "total": "76 621",
        "male": "38 343",
        "female": "38 278"
      },
      "rural": {
        "total": "280 663",
        "male": "140 477",
        "female": "140 186"
      }
    },
    {
      "group": "9 ans",
      "total": "337 685",
      "urban": {
        "total": "74 562",
        "male": "37 362",
        "female": "37 200"
      },
      "rural": {
        "total": "263 123",
        "male": "131 945",
        "female": "131 178"
      }
    },
    {
      "group": "10 ans",
      "total": "332 293",
      "urban": {
        "total": "70 569",
        "male": "35 141",
        "female": "35 428"
      },
      "rural": {
        "total": "261 724",
        "male": "132 211",
        "female": "129 513"
      }
    },
    {
      "group": "11 ans",
      "total": "304 618",
      "urban": {
        "total": "66 957",
        "male": "32 745",
        "female": "34 212"
      },
      "rural": {
        "total": "237 661",
        "male": "119 396",
        "female": "118 265"
      }
    },
    {
      "group": "12 ans",
      "total": "347 052",
      "urban": {
        "total": "73 827",
        "male": "35 534",
        "female": "38 293"
      },
      "rural": {
        "total": "273 225",
        "male": "136 963",
        "female": "136 262"
      }
    },
    {
      "group": "13 ans",
      "total": "334 091",
      "urban": {
        "total": "72 308",
        "male": "34 409",
        "female": "37 899"
      },
      "rural": {
        "total": "261 783",
        "male": "131 236",
        "female": "130 547"
      }
    },
    {
      "group": "14 ans",
      "total": "330 401",
      "urban": {
        "total": "74 984",
        "male": "35 006",
        "female": "39 978"
      },
      "rural": {
        "total": "255 417",
        "male": "127 225",
        "female": "128 192"
      }
    },
    {
      "group": "15 ans",
      "total": "305 053",
      "urban": {
        "total": "71 540",
        "male": "33 282",
        "female": "38 258"
      },
      "rural": {
        "total": "233 513",
        "male": "115 517",
        "female": "117 996"
      }
    },
    {
      "group": "16 ans",
      "total": "287 682",
      "urban": {
        "total": "71 543",
        "male": "33 146",
        "female": "38 397"
      },
      "rural": {
        "total": "216 139",
        "male": "103 023",
        "female": "113 116"
      }
    },
    {
      "group": "17 ans",
      "total": "263 590",
      "urban": {
        "total": "68 780",
        "male": "32 669",
        "female": "36 111"
      },
      "rural": {
        "total": "194 810",
        "male": "92 173",
        "female": "102 637"
      }
    },
    {
      "group": "18 ans",
      "total": "257 258",
      "urban": {
        "total": "68 150",
        "male": "32 502",
        "female": "35 648"
      },
      "rural": {
        "total": "189 108",
        "male": "86 448",
        "female": "102 660"
      }
    },
    {
      "group": "19 ans",
      "total": "222 511",
      "urban": {
        "total": "63 767",
        "male": "30 605",
        "female": "33 162"
      },
      "rural": {
        "total": "158 744",
        "male": "69 342",
        "female": "89 402"
      }
    },
    {
      "group": "20 ans",
      "total": "233 357",
      "urban": {
        "total": "65 825",
        "male": "31 560",
        "female": "34 265"
      },
      "rural": {
        "total": "167 532",
        "male": "70 759",
        "female": "96 773"
      }
    },
    {
      "group": "21 ans",
      "total": "185 587",
      "urban": {
        "total": "57 105",
        "male": "27 099",
        "female": "30 006"
      },
      "rural": {
        "total": "128 482",
        "male": "54 147",
        "female": "74 335"
      }
    },
    {
      "group": "22 ans",
      "total": "199 265",
      "urban": {
        "total": "60 717",
        "male": "29 151",
        "female": "31 566"
      },
      "rural": {
        "total": "138 548",
        "male": "58 083",
        "female": "80 465"
      }
    },
    {
      "group": "23 ans",
      "total": "156 760",
      "urban": {
        "total": "48 485",
        "male": "22 577",
        "female": "25 908"
      },
      "rural": {
        "total": "108 275",
        "male": "45 256",
        "female": "63 019"
      }
    },
    {
      "group": "24 ans",
      "total": "228 836",
      "urban": {
        "total": "72 354",
        "male": "33 839",
        "female": "38 515"
      },
      "rural": {
        "total": "156 482",
        "male": "65 780",
        "female": "90 702"
      }
    },
    {
      "group": "25 ans",
      "total": "178 353",
      "urban": {
        "total": "56 736",
        "male": "26 349",
        "female": "30 387"
      },
      "rural": {
        "total": "121 617",
        "male": "51 248",
        "female": "70 369"
      }
    },
    {
      "group": "26 ans",
      "total": "150 503",
      "urban": {
        "total": "50 431",
        "male": "23 639",
        "female": "26 792"
      },
      "rural": {
        "total": "100 072",
        "male": "42 251",
        "female": "57 821"
      }
    },
    {
      "group": "27 ans",
      "total": "150 547",
      "urban": {
        "total": "49 614",
        "male": "23 434",
        "female": "26 180"
      },
      "rural": {
        "total": "100 933",
        "male": "42 876",
        "female": "58 057"
      }
    },
    {
      "group": "28 ans",
      "total": "157 189",
      "urban": {
        "total": "51 257",
        "male": "23 757",
        "female": "27 500"
      },
      "rural": {
        "total": "105 932",
        "male": "44 373",
        "female": "61 559"
      }
    },
    {
      "group": "29 ans",
      "total": "142 358",
      "urban": {
        "total": "47 712",
        "male": "22 547",
        "female": "25 165"
      },
      "rural": {
        "total": "94 646",
        "male": "40 499",
        "female": "54 147"
      }
    },
    {
      "group": "30 ans",
      "total": "176 131",
      "urban": {
        "total": "54 198",
        "male": "25 672",
        "female": "28 526"
      },
      "rural": {
        "total": "121 933",
        "male": "51 667",
        "female": "70 266"
      }
    },
    {
      "group": "31 ans",
      "total": "165 963",
      "urban": {
        "total": "54 402",
        "male": "26 945",
        "female": "27 457"
      },
      "rural": {
        "total": "111 561",
        "male": "50 747",
        "female": "60 814"
      }
    },
    {
      "group": "32 ans",
      "total": "142 335",
      "urban": {
        "total": "45 859",
        "male": "22 668",
        "female": "23 191"
      },
      "rural": {
        "total": "96 476",
        "male": "42 186",
        "female": "54 290"
      }
    },
    {
      "group": "33 ans",
      "total": "129 477",
      "urban": {
        "total": "40 301",
        "male": "20 355",
        "female": "19 946"
      },
      "rural": {
        "total": "89 176",
        "male": "37 470",
        "female": "51 706"
      }
    },
    {
      "group": "34 ans",
      "total": "145 311",
      "urban": {
        "total": "44 668",
        "male": "23 057",
        "female": "21 611"
      },
      "rural": {
        "total": "100 643",
        "male": "43 854",
        "female": "56 789"
      }
    },
    {
      "group": "35 ans",
      "total": "152 582",
      "urban": {
        "total": "44 241",
        "male": "23 138",
        "female": "21 103"
      },
      "rural": {
        "total": "108 341",
        "male": "46 842",
        "female": "61 499"
      }
    },
    {
      "group": "36 ans",
      "total": "134 721",
      "urban": {
        "total": "38 863",
        "male": "20 212",
        "female": "18 651"
      },
      "rural": {
        "total": "95 858",
        "male": "41 391",
        "female": "54 467"
      }
    },
    {
      "group": "37 ans",
      "total": "122 994",
      "urban": {
        "total": "35 982",
        "male": "18 838",
        "female": "17 144"
      },
      "rural": {
        "total": "87 012",
        "male": "38 114",
        "female": "48 898"
      }
    },
    {
      "group": "38 ans",
      "total": "128 691",
      "urban": {
        "total": "36 562",
        "male": "19 173",
        "female": "17 389"
      },
      "rural": {
        "total": "92 129",
        "male": "39 939",
        "female": "52 190"
      }
    },
    {
      "group": "39 ans",
      "total": "122 701",
      "urban": {
        "total": "34 000",
        "male": "18 081",
        "female": "15 919"
      },
      "rural": {
        "total": "88 701",
        "male": "38 771",
        "female": "49 930"
      }
    },
    {
      "group": "40 ans",
      "total": "140 333",
      "urban": {
        "total": "35 449",
        "male": "18 934",
        "female": "16 515"
      },
      "rural": {
        "total": "104 884",
        "male": "45 563",
        "female": "59 321"
      }
    },
    {
      "group": "41 ans",
      "total": "93 600",
      "urban": {
        "total": "25 402",
        "male": "13 310",
        "female": "12 092"
      },
      "rural": {
        "total": "68 198",
        "male": "29 908",
        "female": "38 290"
      }
    },
    {
      "group": "42 ans",
      "total": "118 645",
      "urban": {
        "total": "29 796",
        "male": "16 030",
        "female": "13 766"
      },
      "rural": {
        "total": "88 849",
        "male": "40 561",
        "female": "48 288"
      }
    },
    {
      "group": "43 ans",
      "total": "83 099",
      "urban": {
        "total": "19 986",
        "male": "10 749",
        "female": "9 237"
      },
      "rural": {
        "total": "63 113",
        "male": "28 292",
        "female": "34 821"
      }
    },
    {
      "group": "44 ans",
      "total": "106 234",
      "urban": {
        "total": "27 158",
        "male": "14 788",
        "female": "12 370"
      },
      "rural": {
        "total": "79 076",
        "male": "36 230",
        "female": "42 846"
      }
    },
    {
      "group": "45 ans",
      "total": "96 425",
      "urban": {
        "total": "23 693",
        "male": "13 006",
        "female": "10 687"
      },
      "rural": {
        "total": "72 732",
        "male": "33 166",
        "female": "39 566"
      }
    },
    {
      "group": "46 ans",
      "total": "72 907",
      "urban": {
        "total": "18 224",
        "male": "9 825",
        "female": "8 399"
      },
      "rural": {
        "total": "54 683",
        "male": "24 662",
        "female": "30 021"
      }
    },
    {
      "group": "47 ans",
      "total": "65 930",
      "urban": {
        "total": "15 784",
        "male": "8 659",
        "female": "7 125"
      },
      "rural": {
        "total": "50 146",
        "male": "23 417",
        "female": "26 729"
      }
    },
    {
      "group": "48 ans",
      "total": "64 095",
      "urban": {
        "total": "15 729",
        "male": "8 657",
        "female": "7 072"
      },
      "rural": {
        "total": "48 366",
        "male": "22 039",
        "female": "26 327"
      }
    },
    {
      "group": "49 ans",
      "total": "67 391",
      "urban": {
        "total": "15 720",
        "male": "8 686",
        "female": "7 034"
      },
      "rural": {
        "total": "51 671",
        "male": "22 909",
        "female": "28 762"
      }
    },
    {
      "group": "50 ans",
      "total": "81 963",
      "urban": {
        "total": "16 852",
        "male": "9 106",
        "female": "7 746"
      },
      "rural": {
        "total": "65 111",
        "male": "27 660",
        "female": "37 451"
      }
    },
    {
      "group": "51 ans",
      "total": "58 951",
      "urban": {
        "total": "13 032",
        "male": "6 965",
        "female": "6 067"
      },
      "rural": {
        "total": "45 919",
        "male": "19 983",
        "female": "25 936"
      }
    },
    {
      "group": "52 ans",
      "total": "89 170",
      "urban": {
        "total": "18 302",
        "male": "9 729",
        "female": "8 573"
      },
      "rural": {
        "total": "70 868",
        "male": "31 891",
        "female": "38 977"
      }
    },
    {
      "group": "53 ans",
      "total": "44 648",
      "urban": {
        "total": "8 602",
        "male": "4 739",
        "female": "3 863"
      },
      "rural": {
        "total": "36 046",
        "male": "16 421",
        "female": "19 625"
      }
    },
    {
      "group": "54 ans",
      "total": "59 326",
      "urban": {
        "total": "11 549",
        "male": "6 289",
        "female": "5 260"
      },
      "rural": {
        "total": "47 777",
        "male": "21 155",
        "female": "26 622"
      }
    },
    {
      "group": "55 ans",
      "total": "54 402",
      "urban": {
        "total": "10 302",
        "male": "5 485",
        "female": "4 817"
      },
      "rural": {
        "total": "44 100",
        "male": "19 586",
        "female": "24 514"
      }
    },
    {
      "group": "56 ans",
      "total": "53 376",
      "urban": {
        "total": "10 061",
        "male": "5 616",
        "female": "4 445"
      },
      "rural": {
        "total": "43 315",
        "male": "20 113",
        "female": "23 202"
      }
    },
    {
      "group": "57 ans",
      "total": "42 403",
      "urban": {
        "total": "7 731",
        "male": "4 258",
        "female": "3 473"
      },
      "rural": {
        "total": "34 672",
        "male": "15 827",
        "female": "18 845"
      }
    },
    {
      "group": "58 ans",
      "total": "43 774",
      "urban": {
        "total": "8 066",
        "male": "4 368",
        "female": "3 698"
      },
      "rural": {
        "total": "35 708",
        "male": "16 508",
        "female": "19 200"
      }
    },
    {
      "group": "59 ans",
      "total": "51 188",
      "urban": {
        "total": "9 125",
        "male": "4 913",
        "female": "4 212"
      },
      "rural": {
        "total": "42 063",
        "male": "19 149",
        "female": "22 914"
      }
    },
    {
      "group": "60 ans",
      "total": "65 888",
      "urban": {
        "total": "10 588",
        "male": "5 435",
        "female": "5 153"
      },
      "rural": {
        "total": "55 300",
        "male": "23 812",
        "female": "31 488"
      }
    },
    {
      "group": "61 ans",
      "total": "43 249",
      "urban": {
        "total": "7 507",
        "male": "3 944",
        "female": "3 563"
      },
      "rural": {
        "total": "35 742",
        "male": "16 386",
        "female": "19 356"
      }
    },
    {
      "group": "62 ans",
      "total": "60 459",
      "urban": {
        "total": "10 152",
        "male": "5 261",
        "female": "4 891"
      },
      "rural": {
        "total": "50 307",
        "male": "24 058",
        "female": "26 249"
      }
    },
    {
      "group": "63 ans",
      "total": "38 572",
      "urban": {
        "total": "6 199",
        "male": "3 236",
        "female": "2 963"
      },
      "rural": {
        "total": "32 373",
        "male": "15 121",
        "female": "17 252"
      }
    },
    {
      "group": "64 ans",
      "total": "51 377",
      "urban": {
        "total": "8 109",
        "male": "4 049",
        "female": "4 060"
      },
      "rural": {
        "total": "43 268",
        "male": "19 416",
        "female": "23 852"
      }
    },
    {
      "group": "65 ans",
      "total": "44 355",
      "urban": {
        "total": "6 797",
        "male": "3 457",
        "female": "3 340"
      },
      "rural": {
        "total": "37 558",
        "male": "17 827",
        "female": "19 731"
      }
    },
    {
      "group": "66 ans",
      "total": "36 572",
      "urban": {
        "total": "5 673",
        "male": "2 913",
        "female": "2 760"
      },
      "rural": {
        "total": "30 899",
        "male": "14 973",
        "female": "15 926"
      }
    },
    {
      "group": "67 ans",
      "total": "30 393",
      "urban": {
        "total": "4 664",
        "male": "2 333",
        "female": "2 331"
      },
      "rural": {
        "total": "25 729",
        "male": "12 508",
        "female": "13 221"
      }
    },
    {
      "group": "68 ans",
      "total": "29 015",
      "urban": {
        "total": "4 492",
        "male": "2 159",
        "female": "2 333"
      },
      "rural": {
        "total": "24 523",
        "male": "11 406",
        "female": "13 117"
      }
    },
    {
      "group": "69 ans",
      "total": "32 914",
      "urban": {
        "total": "4 780",
        "male": "2 283",
        "female": "2 497"
      },
      "rural": {
        "total": "28 134",
        "male": "12 838",
        "female": "15 296"
      }
    },
    {
      "group": "70 ans",
      "total": "41 026",
      "urban": {
        "total": "5 643",
        "male": "2 423",
        "female": "3 220"
      },
      "rural": {
        "total": "35 383",
        "male": "14 846",
        "female": "20 537"
      }
    },
    {
      "group": "71 ans",
      "total": "21 730",
      "urban": {
        "total": "3 254",
        "male": "1 523",
        "female": "1 731"
      },
      "rural": {
        "total": "18 476",
        "male": "8 909",
        "female": "9 567"
      }
    },
    {
      "group": "72 ans",
      "total": "26 473",
      "urban": {
        "total": "3 913",
        "male": "1 827",
        "female": "2 086"
      },
      "rural": {
        "total": "22 560",
        "male": "11 164",
        "female": "11 396"
      }
    },
    {
      "group": "73 ans",
      "total": "17 541",
      "urban": {
        "total": "2 540",
        "male": "1 119",
        "female": "1 421"
      },
      "rural": {
        "total": "15 001",
        "male": "6 786",
        "female": "8 215"
      }
    },
    {
      "group": "74 ans",
      "total": "22 984",
      "urban": {
        "total": "3 180",
        "male": "1 276",
        "female": "1 904"
      },
      "rural": {
        "total": "19 804",
        "male": "8 292",
        "female": "11 512"
      }
    },
    {
      "group": "75 ans",
      "total": "16 398",
      "urban": {
        "total": "2 546",
        "male": "1 000",
        "female": "1 546"
      },
      "rural": {
        "total": "13 852",
        "male": "6 118",
        "female": "7 734"
      }
    },
    {
      "group": "76 ans",
      "total": "11 777",
      "urban": {
        "total": "1 835",
        "male": "748",
        "female": "1 087"
      },
      "rural": {
        "total": "9 942",
        "male": "4 732",
        "female": "5 210"
      }
    },
    {
      "group": "77 ans",
      "total": "9 109",
      "urban": {
        "total": "1 420",
        "male": "586",
        "female": "834"
      },
      "rural": {
        "total": "7 689",
        "male": "3 626",
        "female": "4 063"
      }
    },
    {
      "group": "78 ans",
      "total": "9 315",
      "urban": {
        "total": "1 403",
        "male": "518",
        "female": "885"
      },
      "rural": {
        "total": "7 912",
        "male": "3 469",
        "female": "4 443"
      }
    },
    {
      "group": "79 ans",
      "total": "11 668",
      "urban": {
        "total": "1 787",
        "male": "603",
        "female": "1 184"
      },
      "rural": {
        "total": "9 881",
        "male": "3 962",
        "female": "5 919"
      }
    },
    {
      "group": "80 ans et plus",
      "total": "66 698",
      "urban": {
        "total": "10 301",
        "male": "3 083",
        "female": "7 218"
      },
      "rural": {
        "total": "56 397",
        "male": "21 925",
        "female": "34 472"
      }
    }
  ]
};

const PopulationAgeResidencePage = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [searchTerm, setSearchTerm] = useState('');
  const [mobileOpen, setMobileOpen] = useState(false);
  const [shareAnchorEl, setShareAnchorEl] = useState(null);
  const [downloadAnchorEl, setDownloadAnchorEl] = useState(null);
  const [openKeyStats, setOpenKeyStats] = useState(true);
  const [openAnalysis, setOpenAnalysis] = useState(false);
  const [showDetailedGroups, setShowDetailedGroups] = useState(false);
  
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleShareMenuOpen = (event) => {
    setShareAnchorEl(event.currentTarget);
  };

  const handleDownloadMenuOpen = (event) => {
    setDownloadAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setShareAnchorEl(null);
    setDownloadAnchorEl(null);
  };
  // Calcul des indicateurs clés
const keyStats = {
  totalPopulation: populationData.totalPopulation,
  urbanPopulation: populationData.ageGroups
    .reduce((sum, group) => sum + parseInt(group.urban.total.replace(/\s/g, '')), 0)
    .toLocaleString(),
  ruralPopulation: populationData.ageGroups
    .reduce((sum, group) => sum + parseInt(group.rural.total.replace(/\s/g, '')), 0)
    .toLocaleString(),
  urbanPercentage: (
    (populationData.ageGroups.reduce((sum, group) => sum + parseInt(group.urban.total.replace(/\s/g, '')), 0) /
    parseInt(populationData.totalPopulation.replace(/\s/g, ''))) * 100
  ).toFixed(1),
  ruralPercentage: (
    (populationData.ageGroups.reduce((sum, group) => sum + parseInt(group.rural.total.replace(/\s/g, '')), 0) /
    parseInt(populationData.totalPopulation.replace(/\s/g, ''))) * 100
  ).toFixed(1),
  youthUrbanRatio: (
    (parseInt(populationData.ageGroups[0].urban.total.replace(/\s/g, '')) /
    (parseInt(populationData.ageGroups[0].urban.total.replace(/\s/g, '')) +
     parseInt(populationData.ageGroups[1].urban.total.replace(/\s/g, '')))) * 100
  ).toFixed(1),
  youthRuralRatio: (
    (parseInt(populationData.ageGroups[0].rural.total.replace(/\s/g, '')) /
    (parseInt(populationData.ageGroups[0].rural.total.replace(/\s/g, '')) +
     parseInt(populationData.ageGroups[1].rural.total.replace(/\s/g, '')))) * 100
  ).toFixed(1)
};


  const filteredAgeGroups = populationData.ageGroups.filter(group =>
    !searchTerm || group.group.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const filteredDetailedGroups = populationData.detailedAgeGroups.filter(group =>
    !searchTerm || group.group.toLowerCase().includes(searchTerm.toLowerCase())
  );

  // Composant du menu latéral
  const drawer = (
    <div>
      {isMobile && (
        <MobileDrawerHeader>
          <IconButton onClick={handleDrawerToggle}>
            <Close color="primary" />
          </IconButton>
        </MobileDrawerHeader>
      )}
      <Divider />
      <List>
        {menuItems.map((item) => (
          <ListItem key={item.text} disablePadding>
            <ListItemButton
              component={Link}
              to={item.to}
              onClick={isMobile ? handleDrawerToggle : undefined}
            >
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </div>
  );

  return (
    <MainContainer>
      <CssBaseline />
      <NavigationBar />
      <MainContentWithDrawer>
        {!isMobile ? (
          <DrawerWrapper>
            {drawer}
          </DrawerWrapper>
        ) : (
          <Drawer
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true,
            }}
            sx={{
              '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
            }}
          >
            {drawer}
          </Drawer>
        )}

        <ContentWrapper>
          <Container maxWidth="lg">
            {isMobile && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
                <Button 
                  variant="outlined" 
                  startIcon={<MenuIcon />} 
                  onClick={handleDrawerToggle}
                  sx={{ color: primaryColor, borderColor: primaryColor }}
                >
                  Menu
                </Button>
              </Box>
            )}
            
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Paper sx={{ p: { xs: 1, sm: 3 }, mb: 3, borderLeft: `4px solid ${primaryColor}` }}>
                  <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, mb: 2 }}>
                    <Typography variant="h6" component="h2" fontWeight="bold" color="primary" sx={{ mb: { xs: 1, sm: 0 } }}>
                      {populationData.title}
                    </Typography>
                  </Box>
                  
                  <Grid container spacing={1} style={{ marginTop: '5px', marginBottom: '5px' }}>
                    <Grid item xs={12} sm={6} md={6}>
                      <Button 
                        variant="outlined" 
                        size="small"
                        onClick={() => setShowDetailedGroups(!showDetailedGroups)}
                        sx={{ color: primaryColor, borderColor: primaryColor }}
                      >
                        {showDetailedGroups ? 'Masquer les groupes détaillés' : 'Afficher les groupes détaillés'}
                      </Button>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6}>
                      <TextField
                        size="small"
                        placeholder="Rechercher groupe d'âge..."
                        variant="outlined"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <Search />
                            </InputAdornment>
                          ),
                        }}
                        sx={{ width: { xs: '100%', sm: '480px' } }}
                      />
                    </Grid>
                  </Grid>
                  
                  {/* Section des indicateurs clés */}
                  <Accordion expanded={openKeyStats} onChange={() => setOpenKeyStats(!openKeyStats)} sx={{ mb: 3 }}>
                    <AccordionSummary expandIcon={<ExpandMore />}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        Indicateurs Clés
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Grid container spacing={2}>
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.urbanPopulation}
                              </Typography>
                              <Typography variant="caption">
                                {keyStats.urbanPercentage}% du total
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Population Rurale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.ruralPopulation}
                              </Typography>
                              <Typography variant="caption">
                                {keyStats.ruralPercentage}% du total
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${primaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Jeunesse Urbaine
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.youthUrbanRatio}%
                              </Typography>
                              <Typography variant="caption">
                                Part des 0-14 ans en ville
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                        
                        <Grid item xs={12} md={6} lg={3}>
                          <Card sx={{ height: '100%', borderLeft: `4px solid ${secondaryColor}` }}>
                            <CardContent>
                              <Typography variant="subtitle2" color="text.secondary">
                                Jeunesse Rurale
                              </Typography>
                              <Typography variant="h5" fontWeight="bold">
                                {keyStats.youthRuralRatio}%
                              </Typography>
                              <Typography variant="caption">
                                Part des 0-14 ans en campagne
                              </Typography>
                            </CardContent>
                          </Card>
                        </Grid>
                      </Grid>
                    </AccordionDetails>
                  </Accordion>
                  
                  <TableContainer component={Paper} sx={{ mb: 2, overflowX: 'auto' }}>
                    <Table size="small" aria-label="Tableau de répartition par âge et milieu de résidence">
                      <StyledTableHead>
                        <TableRow>
                          <TableCell rowSpan={2}>Groupe d'âges</TableCell>
                          <TableCell align="center" colSpan={3}>Milieu Urbain</TableCell>
                          <TableCell align="center" colSpan={3}>Milieu Rural</TableCell>
                        </TableRow>
                        <TableRow>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                          <TableCell align="right">Total</TableCell>
                          <TableCell align="right">Masculin</TableCell>
                          <TableCell align="right">Féminin</TableCell>
                        </TableRow>
                      </StyledTableHead>
                      <TableBody>
                        {/* Groupes d'âge principaux */}
                        {filteredAgeGroups.map((group, index) => (
                          <AgeGroupRow key={`main-${index}`} hover>
                            <TableCell component="th" scope="row" sx={{ fontWeight: 'medium' }}>
                              {group.group}
                            </TableCell>
                            <TableCell align="right">{group.urban.total}</TableCell>
                            <TableCell align="right">{group.urban.male}</TableCell>
                            <TableCell align="right">{group.urban.female}</TableCell>
                            <TableCell align="right">{group.rural.total}</TableCell>
                            <TableCell align="right">{group.rural.male}</TableCell>
                            <TableCell align="right">{group.rural.female}</TableCell>
                          </AgeGroupRow>
                        ))}
                        
                        {/* Ligne séparatrice pour les groupes détaillés */}
                        {showDetailedGroups && (
                          <TableRow>
                            <TableCell colSpan={7} sx={{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }}>
                              Groupes d'âge détaillés
                            </TableCell>
                          </TableRow>
                        )}
                        
                        {/* Groupes d'âge détaillés */}
                        {showDetailedGroups && filteredDetailedGroups.map((group, index) => (
                          <AgeGroupRow key={`detail-${index}`} hover>
                            <TableCell component="th" scope="row" sx={{ pl: 4 }}>
                              {group.group}
                            </TableCell>
                            <TableCell align="right">{group.urban.total}</TableCell>
                            <TableCell align="right">{group.urban.male}</TableCell>
                            <TableCell align="right">{group.urban.female}</TableCell>
                            <TableCell align="right">{group.rural.total}</TableCell>
                            <TableCell align="right">{group.rural.male}</TableCell>
                            <TableCell align="right">{group.rural.female}</TableCell>
                          </AgeGroupRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                     {/*
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Tooltip title="Copier le tableau">
                      <IconButton onClick={handleCopyTable} sx={{ color: primaryColor }}>
                        <FileCopy />
                      </IconButton>
                    </Tooltip>
                    
                    <Tooltip title="Télécharger les données">
                      <IconButton 
                        onClick={handleDownloadMenuOpen}
                        sx={{ color: secondaryColor }}
                      >
                        <Download />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={downloadAnchorEl}
                      open={Boolean(downloadAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => downloadFile('xlsx')}>
                        <ListItemIcon>
                          <InsertDriveFile fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Excel (.xlsx)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('csv')}>
                        <ListItemIcon>
                          <Description fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>CSV (.csv)</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => downloadFile('pdf')}>
                        <ListItemIcon>
                          <PictureAsPdf fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>PDF (.pdf)</ListItemText>
                      </MenuItem>
                    </Menu>
                    
                    <Tooltip title="Partager">
                      <IconButton 
                        onClick={handleShareMenuOpen}
                        sx={{ color: primaryColor }}
                      >
                        <Share />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={shareAnchorEl}
                      open={Boolean(shareAnchorEl)}
                      onClose={handleMenuClose}
                    >
                      <MenuItem onClick={() => shareVia('whatsapp')}>
                        <ListItemIcon>
                          <WhatsApp fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>WhatsApp</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('email')}>
                        <ListItemIcon>
                          <Email fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Email</ListItemText>
                      </MenuItem>
                      <MenuItem onClick={() => shareVia('other')}>
                        <ListItemIcon>
                          <MoreVert fontSize="small" />
                        </ListItemIcon>
                        <ListItemText>Autre méthode</ListItemText>
                      </MenuItem>
                    </Menu>
                  </Box>
                  */}
                </Paper>
                
                {/* Section d'analyse démographique */}
                <Accordion expanded={openAnalysis} onChange={() => setOpenAnalysis(!openAnalysis)} sx={{ mb: 2 }}>
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Typography variant="subtitle2" color="primary">
                      Analyse démographique
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Répartition Urbaine/Rurale
                        </Typography>
                        <Typography variant="body2" paragraph>
                          La population burundaise est majoritairement rurale avec {keyStats.ruralPercentage}% des habitants vivant en milieu rural contre seulement {keyStats.urbanPercentage}% en milieu urbain. 
                          Cette répartition reflète la structure économique du pays encore largement basée sur l'agriculture.
                        </Typography>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Structure par âge
                        </Typography>
                        <Typography variant="body2" paragraph>
                          La population jeune (0-14 ans) représente une part importante aussi bien en milieu urbain ({keyStats.youthUrbanRatio}%) qu'en milieu rural ({keyStats.youthRuralRatio}%). 
                          Cette jeunesse de la population présente à la fois un potentiel démographique et des défis en termes d'éducation et d'emploi.
                        </Typography>
                      </Grid>
                      <Grid item xs={12}>
                        <Typography variant="subtitle2" gutterBottom sx={{ fontWeight: 'bold' }}>
                          Disparités de genre
                        </Typography>
                        <Typography variant="body2">
                          Les données montrent une légère surreprésentation des femmes en milieu urbain, particulièrement dans les tranches d'âge actives (15-59 ans). 
                          En milieu rural, cet écart est plus marqué, probablement en raison de la migration masculine vers les villes pour le travail.
                        </Typography>
                      </Grid>
                    </Grid>
                  </AccordionDetails>
                </Accordion>
                
                {/* Notes méthodologiques */}
                <Paper sx={{ p: 2, backgroundColor: '#f0f0f0', borderLeft: `4px solid ${secondaryColor}` }}>
                  <Typography variant="subtitle2" gutterBottom color="primary">
                    Notes méthodologiques
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    Les données présentées proviennent du Recensement Général de la Population, de l'Habitat, de l'Agriculture et de l'Élevage (RGPHAE) 2024. 
                    La classification urbaine/rurale suit les définitions officielles de l'Institut des Statistiques du Burundi. 
                  </Typography>
                </Paper>
              </Grid>
            </Grid>
          </Container>
        </ContentWrapper>
      </MainContentWithDrawer>
      
      {/* Pied de page */}
      <Footer />
    </MainContainer>
  );
};

export default PopulationAgeResidencePage;